import userTransformer from "@mixins/user-transformer";
import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/anunciante",

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(this.url(), userTransformer.parseUser(data))
                .catch(e => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw e;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async find(id) {
            const retorno = await Vue.http.get(this.url(`/${id}`));
            console.log(retorno,"retorno advertisers");
            return userTransformer.formatUser(
                retorno
            );
        },

        async update(data) {
            const url = this.url(`/${data.id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .put(url, userTransformer.parseUser(data))
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async list({ pagination, filters }) {
            const url = this.url(
                `/${pagination.page}/${pagination.amountPerPage}`
            );

            return await Vue.http.get(url, {
                params: {
                    filtro: filters.search,
                    ordem: filters.orderBy,
                    desc: filters.desc
                }
            });
        },

        async count({ filters }) {
            const url = this.url(`/paginacao`);

            return await Vue.http.get(url, {
                params: {
                    filtro: filters.search,
                    ordem: filters.orderBy,
                    desc: filters.desc
                }
            });
        },

        async activate(id) {
            const url = this.url(`/${id}/status`);

            return await Vue.http.put(url);
        },

        async establishments({ establishmentId, search }) {
            const url = this.url(
                `/${establishmentId}/estabelecimento/pesquisa`
            );

            return await Vue.http.get(url, {
                params: {
                    filtro: search
                }
            });
        },

        async bindEstablishment({ advertiserId, establishmentId }) {
            const url = this.url(
                `/${advertiserId}/estabelecimento/${establishmentId}`
            );

            return await Vue.http.post(url);
        },

        async unbindEstablishment({ advertiserId, establishmentId }) {
            const url = this.url(
                `/${advertiserId}/estabelecimento/${establishmentId}`
            );

            return await Vue.http.delete(url);
        },

        async boundEstablishments(id) {
            const url = this.url(`/${id}/estabelecimento`);

            return await Vue.http.get(url);
        },

        async editBinding({ advertiserId, establishmentId, field, value }) {
            const url = this.url(
                `/${advertiserId}/estabelecimento/${establishmentId}`
            );

            return await Vue.http.patch(url, {
                field,
                value
            });
        }
    },
    base
);
